export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-results-demographics-c86d7904c147476065cffec5fe13741c.svg";